<div class="header-wrapper d-none d-lg-block">
  <div class="row m-0">
    <div class="col-12 col-md-3 p-0">
      <div class="header-logo" (click)="onHome()">
        <img src="images/valamar-logo.svg" alt="valamar-logo" />
      </div>
    </div>
    <div class="col-12 col-md-6 p-0">
      <div class="header-navigation">
        <div class="navigation-item" (click)="onNavigateTo(path.Blank)">
          {{ 'Navigation.Home' | translate }}
        </div>
        <div class="navigation-item" (click)="onNavigateTo(path.Bicycles)">
          {{ 'Navigation.Bicycles' | translate }}
        </div>
        <div class="navigation-item" (click)="onNavigateTo(path.CyclingTours)">
          {{ 'Navigation.CyclingTours' | translate }}
        </div>
        <div class="navigation-item" (click)="onNavigateTo(path.CyclingPaths)">
          {{ 'Navigation.CyclingPaths' | translate }}
        </div>
        <div class="navigation-item" (click)="onNavigateTo(path.Articles)">
          {{ 'Navigation.Articles' | translate }}
        </div>
      </div>
    </div>
    <div class="col-12 col-md-3 p-0">
      <div class="header-menu">
        <div class="menu-item language">
          <form [formGroup]="languageForm">
            <mat-form-field appearance="fill" class="language-input">
              <mat-select formControlName="language">
                <mat-option [value]="language.HR">
                  {{ language.HR | uppercase }}
                </mat-option>
                <mat-option [value]="language.EN">
                  {{ language.EN | uppercase }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>
        <div class="menu-item search">
          @if (searchInputDisplayed() === false) {
            <mat-icon (click)="onToggleSearchInput()">search</mat-icon>
          } @else {
            <div class="search-input-wrapper">
              <mat-form-field appearance="outline" class="search-input">
                <mat-label>{{ 'Header.Search' | translate }}</mat-label>
                <input matInput type="text" [formControl]="searchControl" />
                <button
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="onToggleSearchInput()"
                >
                  <mat-icon (click)="onClearSearch()">close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          }
        </div>

        <div class="menu-item cart">
          <mat-icon
            aria-hidden="false"
            (click)="onOpenShoppingCart()"
            [matBadge]="cartItemsCount()"
            matBadgeSize="large"
            >shopping_cart</mat-icon
          >
        </div>
      </div>
    </div>
  </div>
</div>
<div class="header-wrapper-for-mobile d-block d-lg-none">
  <div class="row p-0 m-0">
    <div class="col-2">
      <div class="menu-wrapper-mobile">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="onNavigateTo(path.Blank)">
            <mat-icon>home</mat-icon>
            <span>{{ 'Navigation.Home' | translate }}</span>
          </button>
          <button mat-menu-item (click)="onNavigateTo(path.Bicycles)">
            <mat-icon>directions_bike</mat-icon>
            <span>{{ 'Navigation.Bicycles' | translate }}</span>
          </button>
          <button mat-menu-item (click)="onNavigateTo(path.CyclingTours)">
            <mat-icon>tour</mat-icon>
            <span>{{ 'Navigation.CyclingTours' | translate }}</span>
          </button>
          <button mat-menu-item (click)="onNavigateTo(path.CyclingPaths)">
            <mat-icon>timeline</mat-icon>
            <span>{{ 'Navigation.CyclingPaths' | translate }}</span>
          </button>

          <button mat-menu-item [matMenuTriggerFor]="languages">
            <mat-icon>language</mat-icon>
            <span>{{ 'General.Language' | translate }}</span>
          </button>
          <mat-menu #languages="matMenu">
            <button mat-menu-item (click)="onChangeLanguage(language.EN)">English</button>
            <button mat-menu-item (click)="onChangeLanguage(language.HR)">
              Hrvatski
            </button>
          </mat-menu>
        </mat-menu>
      </div>
    </div>
    <div class="col-8">
      <div class="valamar-logo-mobile" (click)="onHome()">
        <img src="images/valamar-logo.svg" alt="valamar-logo" />
      </div>
    </div>
    <div class="col-2">
      <div class="cart-wrapper-mobile">
        <mat-icon
          aria-hidden="false"
          (click)="onOpenShoppingCart()"
          [matBadge]="cartItemsCount()"
          matBadgeSize="large"
          >shopping_cart</mat-icon
        >
      </div>
    </div>
  </div>
</div>
